import React from 'react';
import { makeStyles, createStyles, Grid } from '@material-ui/core';

import { ClientInput } from './ClientInput';
import { ClientSearch } from './ClientSearch';
import { ClientContext } from '../ClientContext';
import { HomeContext } from '../../Home/HomeContext';
import { SourceModel } from '../../../Models/SourceModel';
import { KeywordModel } from '../../../Models/KeywordModel';
import { ContentModel } from '../../../Models/ContentModel';
import { VehicleModel } from '../../../Models/VehicleModel';
import { OrganogramModel } from '../../../Models/OrganogramModel';
import { ClientClipperModel } from '../../../Models/ClientClipperModel';
import { ExtraParameterModel } from '../../../Models/ExtraParameterModel';
import { ClientModel, clientModelInitial } from '../../../Models/ClientModel';
import { PageLocation } from '../../../shared/enum/PageLocation';
import { CutoutModel } from '../../../Models/CutoutModel';
import { ClientPageTabs } from '../enums/ClientPageTabs';
import { ClientIdmConversionRateModel, ClientIrsConversionRateModel } from '../../../Models/SocialMediaRateModel';
import { ClientProductModel } from '../../../Models/ClientProductModel';

const useStyles = makeStyles(() => createStyles({
    gridContainer: {
        maxWidth: '1152px',
        margin: 0
    },
}));

export function Client() {
    const classes = useStyles();

    const homeContext = React.useContext(HomeContext);

    const [client, setClient] = React.useState<ClientModel>(clientModelInitial);
    const [keywords, setKeywords] = React.useState<KeywordModel[]>([]);
    const [contents, setContents] = React.useState<ContentModel[]>([]);
    const [vehicles, setVehicles] = React.useState<VehicleModel[]>([]);
    const [sources, setSources] = React.useState<SourceModel[]>([]);
    const [extraParameters, setExtraParameters] = React.useState<ExtraParameterModel[]>([]);
    const [clientClippers, setClientClippers] = React.useState<ClientClipperModel[]>([]);
    const [clientList, setClientList] = React.useState<ClientModel[]>([]);
    const [flatOrganogram, setFlatOrganogram] = React.useState<OrganogramModel[]>([]); 
    const [organogramId, setOrganogramId] = React.useState<number>(0);    
    const [cutouts, setCutouts] = React.useState<CutoutModel[]>([]); 
    const [cutoutOrganogram, setCutoutOrganogram] = React.useState<OrganogramModel[]>([]); 
    const [clientPage, setClientPage] = React.useState<ClientPageTabs>(ClientPageTabs.DEFAULT); 
    const [editMode, setEditMode] = React.useState<boolean>(false); 
    const [clientAvatarFile, setClientAvatarFile] = React.useState<File | null>(null); 
    const [primaryColor, setPrimaryColor] = React.useState<string | null>(null); 
    const [secondaryColor, setSecondaryColor] = React.useState<string | null>(null); 
    const [stockSymbol, setStockSymbol] = React.useState<string>(''); 
    const [idmConversionRateList, setIdmConversionRateList] = React.useState<ClientIdmConversionRateModel[]>([]);
    const [irsConversionRateList, setIrsConversionRateList] = React.useState<ClientIrsConversionRateModel[]>([]);
    const [products, setProducts] = React.useState<ClientProductModel[]>([]);

    return (
        <ClientContext.Provider value={{
            client, setClient,
            keywords, setKeywords,
            contents, setContents,
            vehicles, setVehicles,
            sources, setSources,
            extraParameters, setExtraParameters,
            clientList, setClientList,
            flatOrganogram, setFlatOrganogram,
            organogramId, setOrganogramId,
            clientClippers, setClientClippers,
            cutouts, setCutouts,
            cutoutOrganogram, setCutoutOrganogram,
            clientPage, setClientPage,
            editMode, setEditMode,
            clientAvatarFile, setClientAvatarFile,
            primaryColor, setPrimaryColor,
            secondaryColor, setSecondaryColor,
            stockSymbol, setStockSymbol,
            idmConversionRateList, setIdmConversionRateList,
            irsConversionRateList, setIrsConversionRateList,
            products, setProducts
        }}>
            <Grid container justify="center" alignItems="center">
                <Grid container justify="center" className={classes.gridContainer} spacing={2}>   
                    {homeContext.pageLocation === PageLocation.CLIENT_INPUT && <ClientInput /> }
                    {homeContext.pageLocation === PageLocation.CLIENT_EDIT && <ClientInput /> }
                    {homeContext.pageLocation === PageLocation.CLIENT_SEARCH && <ClientSearch /> }
                </Grid>
            </Grid>
        </ClientContext.Provider>
    );

}